import { cn } from '@/lib/utils'
import { Base } from '@/ui/components'
import React, { memo } from 'react'
import { BaseProps } from '../types'

interface Props extends Omit<BaseProps, 'as'> {
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'div'
  mode?: 'default' | 'invert'
  children?: React.ReactNode
}

const Eyebrow = ({
  className,
  as = 'div',
  children,
  mode,
  ...props
}: Props) => {
  if (!children) {
    return null
  }

  return (
    <Base
      as={as}
      className={cn(
        'textstyle-sm-regular',
        mode == 'invert' ? 'text-neutral-200' : 'text-neutral-600',
        className
      )}
      {...props}
      dangerouslySetInnerHTML={{ __html: children as string }}
    />
  )
}

Eyebrow.displayName = 'Eyebrow'

export default memo(Eyebrow)
